<template>
  <div class="warmup-container">
    <Vue3Lottie
      :animationData="newLoader"
      :height="200"
      :width="200"
      alt="global-loader"
    />
  </div>
</template>

<style scoped>
.warmup-container {
  height: 100vh;
  display: grid;
  place-items: center;
}
</style>

<script setup lang="ts">
import { Vue3Lottie } from 'vue3-lottie';

import newLoader from '../assets/new-loader.json';
</script>
